import Dropdown from '@/Shared/Dropdown';
export default {
  components: {
    Dropdown: Dropdown
  },
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      "default": 300
    }
  },
  emits: ['update:modelValue', 'reset']
};